import { render } from "./FourLevel.vue?vue&type=template&id=81260200&scoped=true"
import script from "./FourLevel.vue?vue&type=script&lang=js"
export * from "./FourLevel.vue?vue&type=script&lang=js"

import "./FourLevel.vue?vue&type=style&index=0&id=81260200&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81260200"]])

export default __exports__